module.exports = __webpack_public_path__ + "static/media/right_hill.43ab30c7.svg";